export default __webpack_public_path__ + "static/media/figboss.010f49a9.jpg";